"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

exports.__esModule = true;
exports.n26 = exports.n26Matcher = exports.n26Parser = exports.generateYnabDate = void 0;

require("mdn-polyfills/String.prototype.startsWith");

var papaparse_1 = require("../../util/papaparse");

exports.generateYnabDate = function (input) {
  var match = input.match(/(\d{4})-(\d{2})-(\d{2})/);

  if (!match) {
    throw new Error('The input is not a valid date. Expected format: YYYY-MM-DD');
  }

  var year = match[1],
      month = match[2],
      day = match[3];
  return [month.padStart(2, '0'), day.padStart(2, '0'), year].join('/');
};

exports.n26Parser = function (file) {
  return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , papaparse_1.parse(file, {
            header: true
          })];

        case 1:
          data = _a.sent().data;
          return [2
          /*return*/
          , [{
            data: data.filter(function (r) {
              return r.Date && r['Amount (EUR)'];
            }).map(function (r) {
              return {
                Date: exports.generateYnabDate(r.Date),
                Payee: r.Payee,
                Category: r.Category,
                Memo: r['Payment reference'],
                Outflow: Number(r['Amount (EUR)']) < 0 ? Math.abs(Number(r['Amount (EUR)'])).toFixed(2) : undefined,
                Inflow: Number(r['Amount (EUR)']) > 0 ? Number(r['Amount (EUR)']).toFixed(2) : undefined
              };
            })
          }]];
      }
    });
  });
};

exports.n26Matcher = function (file) {
  return __awaiter(void 0, void 0, void 0, function () {
    var requiredKeys, data, keys, missingKeys;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          requiredKeys = ['Date', 'Payee', 'Transaction type', 'Payment reference', 'Amount (EUR)'];
          return [4
          /*yield*/
          , papaparse_1.parse(file, {
            header: true
          })];

        case 1:
          data = _a.sent().data;

          if (data.length === 0) {
            return [2
            /*return*/
            , false];
          }

          keys = Object.keys(data[0]);
          missingKeys = requiredKeys.filter(function (k) {
            return !keys.includes(k);
          });

          if (missingKeys.length === 0) {
            return [2
            /*return*/
            , true];
          }

          return [2
          /*return*/
          , false];
      }
    });
  });
};

exports.n26 = {
  name: 'N26',
  country: 'de',
  fileExtension: 'csv',
  filenamePattern: /^n26-csv-transactions\.csv/,
  link: 'https://support.n26.com/en-eu/fixing-an-issue/payments-and-transfers/how-to-export-a-list-of-my-transactions',
  match: exports.n26Matcher,
  parse: exports.n26Parser
};